import { useTranslation } from 'react-i18next'
import { EmailProvider, EmailTemplateData, Subscription } from '../../../../types'
import { Alert, InfoTable, Tag } from '../../../../ui'
import { Tooltip } from '../../../../ui/Tooltip'
import { InfoIcon } from '../../../../ui/icons'

export const EmailTable = ({ data, subscription, provider }: { data: EmailTemplateData, subscription?: Subscription, provider: EmailProvider }) => {
    const { t } = useTranslation()
    const validate = (field: string, value: string | undefined, required = true) => {
        if (!value && required) return <Tag variant="warn">{t('missing')}</Tag>
        if (!value) return value
        if (['cc', 'bcc', 'reply_to', 'from_email'].includes(field) && !value.includes('@')) {
            return <Tag variant="warn">{t('invalid_email')}: &quot;{value}&quot;</Tag>
        }
        if (field === 'from_email'
            && provider?.allowed_sending_domains?.split(',')
                .every(domain =>
                    !value.endsWith(domain.trim()),
                )
        ) {
            return <>
                {value}&nbsp;
                <Tag variant="warn">
                    <Tooltip content={t('invalid_email_sender', { domain: provider?.allowed_sending_domains, email: value })}>
                        <>{t('invalid_email')}&nbsp;<InfoIcon /></>
                    </Tooltip>
                </Tag>
            </>
        }
        return value
    }
    const isMissingUnsubscribe = !/\{\{\s?(?:unsubscribeEmailUrl|preferencesUrl)\s?\}\}/.test(data.html ?? '') && !!subscription?.is_public

    return <>
        {isMissingUnsubscribe && <Alert variant="warn" size="small" title={t('unsubscribe_missing_title')} body={t('unsubscribe_missing_message')} />}
        <InfoTable rows={{
            [t('from_email')]: validate('from_email', data.from?.address),
            [t('from_name')]: validate('from_name', data.from?.name),
            [t('reply_to')]: validate('reply_to', data.reply_to, false),
            [t('cc')]: validate('cc', data.cc, false),
            [t('bcc')]: validate('bcc', data.bcc, false),
            [t('subject')]: validate('subject', data.subject),
            [t('preheader')]: data.preheader,
        }} />
    </>
}
